import { IntlShape } from 'react-intl'
import { object, string } from 'yup'

import messages from './messages'

export const partialChannelConnectionSchema = (intl: IntlShape) => {
  return object().shape({
    name: string()
      .min(2, intl.formatMessage(messages.channelConnectionNameMinError))
      .required(intl.formatMessage(messages.channelConnectionNameRequiredError)),
    type: string(),
    claimValueTenantId: string().required(intl.formatMessage(messages.channelConnectionIdRequiredError)),
    jwksUri: string().required(intl.formatMessage(messages.channelConnectionJWKSURIRequiredError))
  })
}
